import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ETranslationNs } from 'src/types'

interface IProps {
  sort: string
  handleSortChange: (sortName: string) => () => void
}

export const THead = ({ sort, handleSortChange }: IProps) => {
  const sortDirection = sort.split('-')[1] as 'desc' | 'asc'
  const sortName = sort.split('-')[0]
  return (
    <TableHead>
      <TableRow 
        style={{ border: 0 }} 
        sx={{ 'td, th': { border: 0 } }}
      >
        <TableCell 
          align="left" 
          width="25%"
        >
          <TableSortLabel
            onClick={handleSortChange('user.email')}
            active={sortName === 'user.email'}
            direction={sortDirection}
            sx={{
              marginLeft: "20px"
            }}
          >
            <HelperWrapper 
              ns={ETranslationNs.TransactionLogs} 
              t="tx-user-table-column" 
            />
          </TableSortLabel>
        </TableCell>
        <TableCell 
          align="center" 
          width="25%"
        >
          <TableSortLabel
            onClick={handleSortChange('account.account_holder')}
            active={sortName === 'account.account_holder'}
            direction={sortDirection}
            sx={{
              marginLeft: "20px"
            }}
          >
            <HelperWrapper
              ns={ETranslationNs.TransactionLogs}
              t="tx-account-account-table-column"
            />
          </TableSortLabel>
        </TableCell>
        <TableCell 
          align="center" 
          width="15%"
        >
          <TableSortLabel
            onClick={handleSortChange('log.explorer_url')}
            active={sortName === 'log.explorer_url'}
            direction={sortDirection}
            sx={{
              marginLeft: "20px"
            }}
          >
            <HelperWrapper ns={ETranslationNs.TransactionLogs} t="tx-explorer-url-column" />
          </TableSortLabel>
        </TableCell>
        <TableCell 
          align="center" 
          width="25%"
        >
          <TableSortLabel
            onClick={handleSortChange('log.created_at')}
            active={sortName === 'log.created_at'}
            direction={sortDirection}
            sx={{
              marginLeft: "20px"
            }}
          >
            <HelperWrapper 
              ns={ETranslationNs.TransactionLogs} 
              t="tx-logs-date-column" 
            />
          </TableSortLabel>
        </TableCell>
        <TableCell 
          align="center" 
          width="10%" 
        />
      </TableRow>
    </TableHead>
  )
}
